module.exports = __webpack_public_path__ + "static/media/chevin_light.3053b81d.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/chevin_light.ttf
// module id = 588
// module chunks = 0